"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../decorators/withStore"));
const CallToActionArea_1 = __importDefault(require("./CallToActionArea"));
const CallArea = (props) => {
    const { activeItem, baseUrl, currentLocale } = props;
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const phoneNumber = activeItem.content.phone;
    const locale = activeItem.content.locale ? activeItem.content.locale : currentLocale;
    (0, react_1.useEffect)(() => {
        if (!activeItem.type && process.env.PLATFORM === "ds") {
            history.push({
                pathname: `${baseUrl}/overview`,
                search: location.search,
            });
        }
    }, [activeItem.type, baseUrl, history, location.search]);
    if (phoneNumber) {
        return (react_1.default.createElement(CallToActionArea_1.default, { mainText: phoneNumber, secondaryText: i18n_js_1.default.t("dictionary.handover.call_message", { locale }), qrValue: phoneNumber }));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
const mapStoreToProps = (store) => ({
    activeItem: store.getValue("activeItem"),
    baseUrl: store.getValue("baseUrl"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(CallArea);
